import {mapState} from 'vuex'
import {getProductInsurersPlanList} from '@/api/common'
export default {
  props:{
  },
  data(){
    const checkSelectPlan = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      let {plan_id} = this.item||{}
      if(!plan_id) {
        callback(new Error('Please select'))
      }
      callback()
    }
    return{
      plan_list:[],
      currentPlanList:[],
      rules:{
        item_plan_id: [
          { validator: checkSelectPlan, trigger: ['change', 'blur'] }
        ],
      },
    }
  },
  computed:{
    getCurrentPlanName(){
      return (index,plan_id)=>{
        let name = this.getOptionName('',plan_id,this.plan_list[index])
        return name||''
      }
    },
  },
  methods:{
    async changeCompanyPlanList(){
      let index = this.activeQuote
      const {class_id, company_id, trm_of_cvr} = this.quoteList[index]||{}
      let params = {
        class_id,
        company_id,
        trm_of_cvr,
        merchant_platform:this.isFina?2:1
      }
      let {data} = await getProductInsurersPlanList(params)
      let {plans=[]} = data||{}
      this.plan_list[index] = plans
      this.formDataLock+=1
    },
    async getInitPlanList(item,index){
      const {class_id, company_id, trm_of_cvr,plan_id} = item||{}
      let params = {
        class_id,
        company_id,
        trm_of_cvr,
        merchant_platform:this.isFina?2:1
      }
      let {data} = await getProductInsurersPlanList(params)
      let {plans=[]} = data||{}
      this.plan_list[index] = plans
      if(this.productId==11)
        this.quoteList[index].plan_id = plan_id
    },
  }
}
